var _rect, _polyline, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallerySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 9.16,
    width: 45.69,
    height: 45.69,
    rx: 2.51
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9.16 41.95 20.68 32.19 29.71 40.38 43.27 23.51 54.77 40.38"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.76,
    cy: 19.38,
    r: 3.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallerySvgrepoCom);
export default __webpack_public_path__ + "static/media/gallery-svgrepo-com.004004335eb4a85292f9f1b8df9ac4a1.svg";
export { ForwardRef as ReactComponent };